import {
  SUBMENU_DEFAULT_VALUE,
  SUBMENU_PARAM_ARCHIVE_VALUE,
} from '../../../constants/route'

export const QA_NAME_ENTITY_TAB_INHABITANTS_ADD_NEW =
  'entityTabInhabitantsAddNew'

export const ENTITY_TAB_INHABITANTS_SUB_TAB_ORDER = [
  SUBMENU_DEFAULT_VALUE,
  SUBMENU_PARAM_ARCHIVE_VALUE,
]

export const ENTITY_TAB_INHABITANTS_SUB_TAB_TEXT_KEY = {
  [SUBMENU_DEFAULT_VALUE]: 'InhabitantTable.SubTabAllKey',
  [SUBMENU_PARAM_ARCHIVE_VALUE]: 'InhabitantTable.SubTabArchiveKey',
}

export const ENTITY_TAB_INHABITANTS_SUB_TAB_QA_NAME = {
  [SUBMENU_DEFAULT_VALUE]: 'entityTabInhabitantsSubTabAll',
  [SUBMENU_PARAM_ARCHIVE_VALUE]: 'entityTabInhabitantsSubTabArchive',
}
